import {
    LIST_ACTS,
    LIST_ACTS_SUCCESS,
    LIST_ACTS_ERROR,
    ADD_ACTS,
    SAVE_ACTS,
    SAVE_ACTS_SUCCESS,
    SAVE_ACTS_ERROR,
    DELETE_ACTS,
    DELETE_ACTS_SUCCESS,
    DELETE_ACTS_ERROR,
    EDIT_ACTS,
    UPDATE_ACTS,
    UPDATE_ACTS_SUCCESS,
    UPDATE_ACTS_ERROR,
    MIGRATE_ACTS,
    MIGRATE_ACTS_SUCCESS,
    MIGRATE_ACTS_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS, MSG_MIGRATE_ACT_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';

const controller = 'actuacion';

//LISTAR ACTS
export function listActsAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listActs() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const acts = response.data;
            //const acts = actsData;
            //Llamo al dispatch
            dispatch( listActsSuccess(acts.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listActsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listActs = () => ({
    type: LIST_ACTS,
    payload: true
});

const listActsSuccess = acts => ({
    type: LIST_ACTS_SUCCESS,
    payload: acts
});

const listActsError = error => ({
    type: LIST_ACTS_ERROR,
    payload: error
});

//ADD AUDIENCE CATEGORY
export function addActsAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addActs(false) );
        //Abro el formulario
        showForm();
    }
}

const addActs = isEdit => ({
    type: ADD_ACTS,
    payload: isEdit
});

//SAVE ACT
export function saveActsAction(act, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveActs() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, act);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveActsSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveActsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveActs = () => ({
    type: SAVE_ACTS,
    payload: true
});


const saveActsSuccess = act => ({
    type: SAVE_ACTS_SUCCESS,
    payload: act
});

const saveActsError = error => ({
    type: SAVE_ACTS_ERROR,
    payload: error
});

//EDIT ACT
export function editActsAction(act, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editActs(act) );
        //Abro el formulario
        showForm();
    }
}

const editActs = act => ({
    type: EDIT_ACTS,
    payload: act
});

//UPDATE ACT
export function updateActsAction(act, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateActs() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${act.id}`, act);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateActsSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateActsError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateActs = () => ({
    type: UPDATE_ACTS,
    payload: true
});

const updateActsSuccess = act => ({
    type: UPDATE_ACTS_SUCCESS,
    payload: act
});

const updateActsError = error => ({
    type: UPDATE_ACTS_ERROR,
    payload: error
});

//DELETE ACT
export function deleteActsAction(act) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteActs() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.delete(`/${controller}/${act.id}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteActsSuccess(act.id) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteActsError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteActs = () => ({
    type: DELETE_ACTS,
    payload: true
});

const deleteActsSuccess = act => ({
    type: DELETE_ACTS_SUCCESS,
    payload: act
});

const deleteActsError = error => ({
    type: DELETE_ACTS_ERROR,
    payload: error
});

//MIGRATE ACTS
export function migrateActsAction(act) {
    return async (dispatch) => {
        //Inicializo
        dispatch( migrateActs() );
        //Ejecuto la consulta
        try{
            WaitingMessage('Migrando Acta');
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/acta/migrar-sae/${act.id}`, act);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( migrateActsSuccess(response.data) );
            //Oculto la espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_MIGRATE_ACT_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( migrateActsError(data) );
            //Oculto la espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const migrateActs = () => ({
    type: MIGRATE_ACTS,
    payload: true
});

const migrateActsSuccess = act => ({
    type: MIGRATE_ACTS_SUCCESS,
    payload: act
});

const migrateActsError = error => ({
    type: MIGRATE_ACTS_ERROR,
    payload: error
});